import axios from "axios";

export default {
    getEntidades() {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = {
            headers: {
                Authorization: `${tokenAuth}`
            }
        };

        return axios
            .get("api/entidades/", headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getMunicipios(entidadId) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = {
            headers: {
                Authorization: `${tokenAuth}`
            }
        };

        return axios
            .get("api/municipios/" + entidadId, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getEntidadesPublic() {
        let token = localStorage.getItem("tokenAcceso");
        let usuarioId = localStorage.getItem("usuarioId");

        return axios
            .get(`api/entidades-public`, {
                params: {
                    usuarioId: usuarioId,
                    token: token
                }
            })
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getMunicipiosPublic(entidadId) {
        let token = localStorage.getItem("tokenAcceso");
        let usuarioId = localStorage.getItem("usuarioId");

        return axios
            .get(`api/municipios-public/${entidadId}`, {
                params: {
                    usuarioId: usuarioId,
                    token: token
                }
            })
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },
};